export default __webpack_public_path__ + "static/Крысиные бега_0-feda173f7ba9e0f7bacfe788e44b336d.jpg";